import $ from 'jquery';
import 'slick-carousel';

$(function() {

  var $imageSliderContent = $('.image-slider-content');

  $imageSliderContent.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<span class="icon-chevron-left"></span>',
    nextArrow: '<span class="icon-chevron-right"></span>',
    dots: true,
    fade: false,
    cssEase: 'ease-in-out',
    centerMode: true,
    centerPadding: '15vw',
    pauseOnHover: false,
    autoplay: true,
    autoplaySpeed: 6000,
    responsive: [
        {
            breakpoint: 480,
            settings: {
                centerPadding: '0px',
            }
        }
    ]
  });
});